import React from 'react';
import type { BaseTileProps } from './types';

export const BaseTile: React.FC<BaseTileProps> = ({
  children,
  width,
  height,
  className = '',
  style,
  onClick,
  onMouseEnter,
  onMouseLeave,
  interactive = false,
  rounded = false
}) => {
  const isClickable = interactive || !!onClick;

  const classes = [
    'core-tile',
    isClickable && 'core-tile--interactive',
    rounded && 'core-tile--rounded',
    className
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        ...style
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
    >
      {children}
    </div>
  );
};
